module.exports = __webpack_public_path__ + "img/enterprise.9ebcafd6.svg";